/**
 * Full Frame brand mark — uses the real client logo (purple→magenta→red
 * gradient square with the white `L]` mark).  The PNG lives at
 * `/fullframe-logo.png` in the frontend public folder so it's served from
 * the same origin and benefits from browser caching.
 */
export function FullFrameLogo({ size = "md", showWord = true, className = "" }) {
  const sizes = {
    sm: { box: "h-8 w-8", text: "text-base" },
    md: { box: "h-12 w-12", text: "text-2xl" },
    lg: { box: "h-16 w-16", text: "text-3xl sm:text-4xl" },
  }[size];

  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="fullframe-logo">
      <img
        src="/fullframe-logo.png"
        alt="Full Frame"
        className={`${sizes.box} rounded-2xl object-cover shadow-lg shadow-pink-500/30 ring-1 ring-white/20`}
        loading="eager"
      />
      {showWord && (
        <span
          className={`font-sans ${sizes.text} font-light tracking-[0.25em] uppercase bg-gradient-to-r from-fuchsia-500 via-pink-500 to-orange-500 bg-clip-text text-transparent`}
        >
          Full·Frame
        </span>
      )}
    </div>
  );
}

// Brand utility classes — re-tuned to match the new logo's palette
// (magenta → pink → red instead of the previous violet → orange).
export const ffGradient = "bg-gradient-to-br from-fuchsia-600 via-pink-500 to-red-500";
export const ffGradientText = "bg-gradient-to-r from-fuchsia-600 via-pink-500 to-red-500 bg-clip-text text-transparent";
